export const removeAccents = (str) =>
  str ? str.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : str;

export const getOnlyNumbers = (str) => {
  if (!str || typeof str !== "string") {
    return "";
  }

  const number = Number.parseInt(str.replace(/\D/gi, ""), 10);

  return Number.isNaN(number) ? "" : `${number}`;
};
